
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"8","viewBox":"0 0 13 8","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.95945 0.835065L6.4935 5.82376L11.0526 0.835065C11.6538 0.160917 12.6808 1.26652 12.0546 1.94067L6.91935 7.63048C6.6939 7.87317 6.31815 7.87317 6.11775 7.63048L0.932401 1.94067C0.331201 1.26652 1.35825 0.160917 1.95945 0.835065Z"}})])
          )
        }
      }
    